import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { ColumnVisibility } from '../../../core/model/column-definition';
import { UserGroupService } from '../../service/data/user-group.service';
import { UserGroup } from '../../model/user-group';

@Component({
    selector: 'app-user-group-manager',
    templateUrl: './../../../core/component/multiselect-object-manager/multiselect-object-manager.template.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserGroupManagerComponent extends MultiselectObjectManagerComponentBase<UserGroup> {
  constructor(
    cdf: ColumnDefinitionFactory,
    dataService: UserGroupService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: StandardCommandHandlerResolver
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = [cdf.create('USERGROUP.NAME', 'name', ColumnVisibility.mandatory)];
    this.title = 'USERGROUP.LIST_HEADER';
    this.preferencesKey = 'common.user-group.list';
  }
}
